import { StyleSheet } from 'react-native';

import {
  neutralDark,
  neutralLight,
  neutralWhite,
} from '../../../constants/color';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: neutralWhite,
  },
  marketEvents: {
    marginBottom: 10,
  },
  emptyWrapper: {
    minHeight: 372,
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: neutralWhite,
  },
  emptyText: {
    marginTop: 10,
    textAlign: 'center',
    fontSize: 12,
    color: neutralDark,
  },
  separator: {
    flex: 1,
    maxHeight: 1,
    minHeight: 1,
    marginBottom: 0,
    padding: 0,
    borderStyle: 'solid',
    borderTopWidth: 1,
    borderColor: neutralLight,
  },
  goToShopBtnWrapper: {
    marginTop: 20,
  },
  goToShopBtn: {
    minWidth: 120,
  },
});

export default styles;
